import axios from "../utilities/api/axiosInstance";
import { printInConsole } from "@utils/devtools/utils";

export const getListCommunity = async ({ search, page = 0, accessToken }) => {
  /*
  Returns the list of communities based on search term
  accessToken --> required
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(
      `search/community?` + new URLSearchParams({ q: search, page: page })
    ),
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
};

export const getCommunity = async ({ communityID, accessToken }) => {
  /*
  Returns the data of the community with the given id
  accessToken --> required
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(`community?communityID=${communityID}`),
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  //console.log("user data access token====>", reqOptions);

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  //console.log("Community Profile=======>", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
};

export const getCommunitySingleFeed = async ({
  feedID,
  accessToken,
  cancelToken,
}) => {
  /*
  Returns the data of the community with the given id
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(`feed?feedID=${feedID}`),
    cancelToken: cancelToken,
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }
  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  printInConsole(response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
};

export async function getCommunityFeeds({
  communityID,
  postType,
  ts = 0,
  accessToken,
  cancelToken,
}) {
  /*
  communityID --> id of the community whose feed to return
  postType --> constant to indicate "posts"/"clips"
  */

  let params = "";
  if (ts === 0) {
    params = new URLSearchParams({
      communityID: communityID,
      postType: postType,
    });
  } else {
    params = new URLSearchParams({
      communityID: communityID,
      postType: postType,
      ts: ts,
    });
  }

  const link = "community/feed/v2?" + params;

  const reqOptions = {
    method: "GET",
    url: encodeURI(link),
    cancelToken: cancelToken,
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const result = await axios(reqOptions).catch((err) => printInConsole(err));

  //console.log("GetCommunityFeeds => ", result.data);

  if (result?.data?.success) return result.data.response;

  return [];
}

export async function reportCommunity({ communityID, accessToken }) {
  /*
  communityID --> communityID of the community to be reported
  Returns true/false
  */

  const response = await axios({
    method: "POST",
    url: encodeURI("community/report"),
    data: { communityID: communityID },
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Report Community response => ", response);

  // if (response?.data) return response.data.success;
  // else return false;
  return response?.data;
}

export async function deleteCommunity({ communityID, ownerUid, accessToken }) {
  /*,
  Delete community --- returns true/false --
  */

  const response = await axios({
    method: "DELETE",
    url: encodeURI("community"),
    data: { communityID, ownerUid },
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Delete Community response => ", response);
  if (response) return response.data?.success;
  else return false;
}

export async function getAllMembers({
  communityID,
  joiningTime = 0,
  accessToken,
}) {
  /*
  Returns the list of members of the community
  */

  let data = null,
    err = null;

  let URL = null;
  if (joiningTime === 0) URL = `community/member?communityID=${communityID}`;
  else
    URL = `community/member?communityID=${communityID}&joiningTime=${joiningTime}`;

  const reqOptions = {
    method: "GET",
    url: encodeURI(URL),
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  //printInConsole("getAllMembers => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

export async function requestToJoin({ communityID, accessToken }) {
  /*
  Request to join the community by the current user

  returns true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("community/member"),
    data: { communityID },
  });

  //console.log("requestToJoin => ", response);

  // if (response?.data)
  //   return { success: response.data.success, response: response.data.response };
  // else return false;
  return response?.data;
}

export async function getMemberRequests({
  communityID,
  ts = 0,
  accessToken,
  cancelToken,
}) {
  /*
  Returns the list of members of the community
  */

  let data = null,
    err = null;

  let URL = null;
  if (ts === 0) URL = `community/member/requests?communityID=${communityID}`;
  else URL = `community/member/requests?communityID=${communityID}&ts=${ts}`;

  const reqOptions = {
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(URL),
    cancelToken: cancelToken,
  };

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  //printInConsole("getMemberRequests => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

export async function approveMemberRequest({ uid, communityID, accessToken }) {
  /*
  Approve the Request of the user with given uid
  to join the community(given communityID) 

  returns true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("community/member/request/approve"),
    data: { communityID, uid },
  });

  printInConsole("approveMemberRequest => ", response);

  // if (response?.data) return response.data.success;
  // else return false;
  return response?.data;
}

export async function rejectMemberRequest({ uid, communityID, accessToken }) {
  /*
  Reject the Request of the user with given uid
  to join the community(given communityID) 

  returns true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI("community/member/request/decline"),
    data: { communityID, uid },
  });

  printInConsole("rejectMemberRequest => ", response);

  if (response?.data) return response.data.success;
  else return false;
}

export async function leaveMembership({ uid, memberID, accessToken }) {
  /*
  Leave membership of a community

  returns true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI("community/member"),
    data: { memberID, uid },
  });

  printInConsole("leaveMembership => ", response);

  if (response?.data) return response.data.success;
  else return false;
}

export async function removeMember({ communityID, memberID, accessToken }) {
  /*
  Remove member by the owner of the community(given communityID)

  returns true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI("community/member/admin"),
    data: { memberID, communityID },
  });

  printInConsole("RemoveMember => ", response);

  if (response?.data) return response.data.success;
  else return false;
}

export async function assignRoleToMember({
  communityID,
  memberID,
  role,
  accessToken,
}) {
  /*
  Assign role to a member of the community(given communityID) by owner/admin

  returns true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "PUT",
    url: encodeURI("community/member/assign"),
    data: { memberID, communityID, role },
  });

  printInConsole("assignRoleToMember => ", response);

  if (response?.data) return response.data.success;
  else return false;
}

export async function getCommunityTypes(accessToken) {
  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI("user/communityTypes"),
  }).catch((e) => printInConsole(e));

  printInConsole(response.data);

  if (response?.data?.success) return response.data.response;

  return null;
}
export async function getOrganisationTypes(accessToken) {
  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI("community/getAllOrganisationType"),
  }).catch((e) => printInConsole(e));

  printInConsole(response.data);

  if (response?.data?.success) return response.data.response;

  return null;
}
export async function uploadDpCover({ dp, cover, accessToken }) {
  /*
  Upload dp and cover of community
  */

  const formData = new FormData();
  formData.append("image", dp);
  formData.append("image", cover);

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("community/image"),
    data: formData,
  }).catch((err) => printInConsole(err));

  printInConsole("uploadDpCover => ", response);

  // if (response?.data?.success) return response.data.response;
  // return null;
  return response?.data;
}

export async function inviteUser({ users, accessToken }) {
  let data = null,
    err = null;
  // console.log(users);

  const reqOptions = {
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    data: users,
    url: encodeURI(`community/member/invite`),
  };

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  printInConsole(response);

  // if (response?.data?.success) data = response?.data?.response;
  // else if (response?.data?.message) err = response.data.message;

  // return { data, err };
  return response?.data;
}

export async function approveMemberInvitation({
  uid,
  communityID,
  accessToken,
}) {
  /*
  Approve the Request of the user with given uid
  to join the community(given communityID) 

  returns true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("community/member/invitation/approve"),
    data: { communityID, uid },
  });

  printInConsole("approveMemberInvitation => ", response);

  // if (response?.data) return response.data.success;
  // else return false;
  return response?.data;
}

export async function rejectMemberInvitation({
  uid,
  communityID,
  accessToken,
}) {
  /*
  Reject the Request of the user with given uid
  to join the community(given communityID) 

  returns true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI("community/member/invitation/decline"),
    data: { communityID, uid },
  });

  printInConsole("rejectMemberInvitation => ", response);

  // if (response?.data) return response.data.success;
  // else return false;
  return response?.data;
}

export async function createCommunity({ data, accessToken }) {
  /*
  data -->  { ... } **--??--**
  create-community request
  returns the community data
  */

  // console.log({ data, accessToken });

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("community"),
    data: data,
  }).catch((err) => printInConsole(err));

  printInConsole("createCommunity => ", response);

  // if (response?.data?.success) return response.data.response;
  // return null;
  return response?.data;
}

export async function updateDpCover({
  type,
  file,
  communityID,
  data,
  accessToken,
}) {
  /*
  type --> constant indicating dp/cover
  file --> image file
  data --> { isSharing, caption, uid** }

  Update dp and cover of community
  returns the url of the uploaded image in an array
  */

  const formData = new FormData();
  formData.append("image", file);
  formData.append("communityID", communityID);
  formData.append("isSharing", data.isSharing);
  formData.append("caption", data.caption);
  formData.append("uid", data.uid);

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "PUT",
    url: encodeURI(`community/update/${type}`),
    data: formData,
  }).catch((err) => printInConsole(err));

  if (response?.data?.success) return response.data.response;
  return null;
}

export async function updateCommunity({ data, accessToken }) {
  /*
  data -->  { ... } **--??--**
  update-community request
  returns true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "PUT",
    url: encodeURI("community"),
    data: data,
  }).catch((err) => printInConsole(err));

  if (response?.data) return response.data.success;
  return false;
}

export async function upvoteCommunity({
  communityID,
  upvoterUid,
  deviceID,
  accessToken,
  ts,
}) {
  /*
  upvote a community
  returns true or false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("community/upvote"),
    data: { communityID, upvoterUid, deviceID, ts },
  }).catch((err) => printInConsole(err));

  // console.log("Upvote res => ", response);

  // if (response?.data) return response.data.success;
  // else return false;
  return response?.data;
}

export async function removeUpvoteCommunity({ communityID, accessToken }) {
  /*
  remove upvote of a community
  returns true or false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI("community/upvote"),
    data: { communityID },
  }).catch((err) => printInConsole(err));

  printInConsole("Remove Upvote res => ", response);

  if (response?.data) return response.data.success;
  else return false;
}

export async function getUpvotersList({ communityID, ts = 0, accessToken }) {
  /*
  returns the Upvoters list of a community
  */

  let url = null;
  if (ts == 0) url = `community/upvote?communityID=${communityID}`;
  else url = `community/upvote?communityID=${communityID}&ts=${ts}`;

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(url),
  }).catch((err) => printInConsole(err));

  printInConsole("Upvoters List => ", response);

  if (response?.data?.success) return response.data.response;
  else return [];
}

/* ------ to be updated -------------*/
export async function getFestivalTypes(token, accessToken) {
  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI("user/festivalTypes"),
    cancelToken: token,
  }).catch((e) => printInConsole(e));

  printInConsole(response);

  if (response?.data?.success) return response.data.response;

  return null;
}

export async function getInterestCommunities({ interests, accessToken }) {
  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(`user/interestCommunities`),
  }).catch((e) => printInConsole(e));

  //console.log(response);

  if (response?.data?.success) return response.data.response;

  return null;
}

export async function getUpvotingStatus({ typeID, cancelToken }) {
  /*
  returns true/ false --> upvoting is on/off
  */

  const response = await axios({
    method: "GET",
    url: encodeURI(`miscellaneous/upvoting?typeID=${typeID}`),
    cancelToken: cancelToken,
  }).catch((e) => printInConsole(e));

  printInConsole("Upvoting Status => ", response);

  if (response?.data?.success) return response.data.response;

  return null;
}

export async function bulkCommunityJoin({ communityIDs, accessToken }) {
  // console.log("Bulk Community Join CommunityIDs=> ", communityIDs);
  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("community/member/bulkjoin"),
    data: { communityIDs },
  }).catch((err) => printInConsole(err));

  //console.log("Bulk Community Join => ", response);

  // if (response?.data?.success) return response.data.success;
  // return null;
  return response?.data;
}

export async function getSuggestedCommunities({ accessToken }) {
  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(`user/suggestedCommunities`),
  }).catch((e) => printInConsole(e));

  //console.log(response);

  if (response?.data?.success) return response.data.response;

  return null;
}

export async function getMemberDetails({ communityID, accessToken }) {
  const reqOptions = {
    method: "GET",
    url: encodeURI(`community/member/single?communityID=` + communityID),
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }
  const response = await axios(reqOptions).catch((error) => {
    // err = error;
    printInConsole(error);
  });

  if (response?.data?.success) return response.data.response;

  return null;
}
